import {
  DaxoLeadFramesIcon,
  DaxoSingleFrameIcon,
  LinkIcon,
} from '@global-engineering-shared/gweb-material-icons-global-next';
import { ReactNode } from 'react';

import EntityIconContainer from 'features/Entity/components/EntityActionBar/components/EntityIconContainer/EntityIconContainer';
import { EntityType } from 'types/entityType';

export const getEntityIcon = (entityType: EntityType): ReactNode => {
  switch (entityType) {
    case EntityType.LINKED_ASSET:
      return (
        <EntityIconContainer>
          <DaxoLeadFramesIcon titleAccess="LinkedAssetIcon" />
        </EntityIconContainer>
      );
    case EntityType.LINKED_ASSET_FRAME:
      return (
        <EntityIconContainer>
          <LinkIcon titleAccess="LinkedAssetFrameIcon" />
        </EntityIconContainer>
      );
    default:
      return (
        <EntityIconContainer>
          <DaxoSingleFrameIcon titleAccess="FrameIcon" />
        </EntityIconContainer>
      );
  }
};
